import ListItem from "./index";

function CourseListItem({ data, ...props }) {
  return (
    <ListItem
      {...props}
      itemId={data.id}
      href={`/course-pack/${data.code}/`}
      aria-label={`${data.name} course pack`}
      aria-describedby={`bccampus-list-item-extra-${data.id}`}
      coverImage={data.image}
      title={data.name}
      extra={data.concepts["educational-level"]
        ?.map((level) => level)
        .join(", ")}
      meta={
        <span>
          {data.concepts.subject?.map((subject) => subject).join(", ")}
        </span>
      }
    />
  );
}

export default CourseListItem;
